import { reauthenticateWithCredential, updatePassword } from "firebase/auth";
import React, { useState, useEffect, useRef } from "react";
import { EmailAuthProvider } from "firebase/auth";
import { FirebaseError } from "firebase/app";
import UpdatedRefresh from "../../../images/UpdatedRefresh.svg";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { msgType } from "../../../utils/types";
import { Operation } from "../../../utils/Enum.types";
import { auth } from "../../../firebase";
import { EMPTY_STRING } from "../../../utils/constants";
import { Title } from "../../../stories/Title/Title";
import { Keys } from "../../../utils/Enum.keys";
import { Label } from "../../../stories/Label/Label";
import { Button } from "../../../stories/Button/Button";
import MessageModal from "../../../customComponents/MessageModal";
import { useMutation } from "@apollo/client";
import { ResetEmpPassword } from "../../../queries/queries";
import {
  ResetEmpPasswordInput,
  ResetEmpPasswordOutput,
} from "../../../queries/types";
import useLoggedInUserDetails from "../../../customHooks/useLoggedInUserDetails";
import useUrlParams from "../../../customHooks/useUrlParams";
import { handleSignOut } from "./Header";
import Close from "../../../images/Close.svg"
interface Props {
  setPasswordModal: React.Dispatch<React.SetStateAction<boolean>>;
}
const ChangePassword = ({ setPasswordModal }: Props) => {
  const [captchaText, setCaptchaText] = useState<string>("");
  const [userInput, setUserInput] = useState<string>("");

  const { customer_id } = useUrlParams();

  const [ResetPwd] = useMutation<ResetEmpPasswordOutput, ResetEmpPasswordInput>(
    ResetEmpPassword
  );

  const { user_details } = useLoggedInUserDetails();
  const generateCaptcha = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let captcha = "";
    for (let i = 0; i < 6; i++) {
      captcha += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    setCaptchaText(captcha);
    setUserInput("");
  };
  const [newPassword, setNewPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = React.useState(false);
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [message, setMessage] = useState<msgType>({
    message: "",
    flag: false,
    operation: Operation.NONE,
  });

  const newPasswordRef = useRef<HTMLInputElement>(null);
  const confirmPasswordRef = useRef<HTMLInputElement>(null);
  const captchaCodeRef = useRef<HTMLInputElement>(null);
  const saveRef = useRef<HTMLButtonElement>(null);
  const updatePasswordWithReauthentication = () => {
    const currentUser = auth.currentUser;
    const credential = EmailAuthProvider.credential(
      currentUser?.email!,
      oldPassword
    );
    if (newPassword !== confirmPassword) {
      setMessage({
        flag: true,
        message: "Passwords do not match",
        operation: Operation.NONE,
      });
    } else if (oldPassword === newPassword) {
      setMessage({
        flag: true,
        message: "New password must be different from the current password",
        operation: Operation.NONE,
      });
    } else if (captchaText !== userInput) {
      setMessage({
        flag: true,
        message: "Captcha do not match , Please Try Again",
        operation: Operation.NONE,
      });
    } else if (currentUser) {
      if (customer_id)
        reauthenticateWithCredential(currentUser, credential)
          .then((user) => {
            ResetPwd({
              variables: {
                empID: user_details.id,
                customerID: customer_id,
                password: newPassword,
                user_details,
              },
            })
              .then(() => {
                setMessage({
                  flag: true,
                  message: "Password updated successfully",
                  operation: Operation.UPDATE,
                });
              })
              .catch((e: FirebaseError) => {
                setMessage({
                  flag: true,
                  message: e.message,
                  operation: Operation.NONE,
                });
              });
          })
          .catch((e: FirebaseError) => {
            setMessage({
              flag: true,
              message: e.message,
              operation: Operation.NONE,
            });
          });
    }
  };
  const handleClickShowPassword = (field: string) => {
    switch (field) {
      case "current":
        setShowCurrentPassword((show) => !show);
        break;
      case "new":
        setShowNewPassword((show) => !show);
        break;
      case "confirm":
        setShowConfirmPassword((show) => !show);
        break;
      default:
        break;
    }
  };
  const handleUserInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUserInput(event.target.value);
  };
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };
  const handleClear = () => {
    setOldPassword(EMPTY_STRING);
    setNewPassword(EMPTY_STRING);
    setConfirmPassword(EMPTY_STRING);
    setUserInput(EMPTY_STRING);
  };
  const handleBack = () => {
    if (message.operation !== Operation.NONE && message.flag) {
      handleSignOut();
      handleClear();
      setPasswordModal(false);
    }
    setMessage({
      flag: false,
      message: "",
      operation: Operation.NONE,
    });
  };
  useEffect(() => {
    generateCaptcha();
  }, []);
  return (
    <>
     
      <div className="change-password">
        <div className="change-password__title">
        <Title>Change Password</Title>
        <img src={Close} alt="" onClick={() => setPasswordModal(false)}/>
        </div>
        <div className="change-password__block">

        <TextField
          required
          value={oldPassword}
          className="change-password__textfield"
          name="password"
          type={showCurrentPassword ? "text" : "password"}
          onChange={(e) => setOldPassword(e.target.value)}
          label="Current Password"
          autoFocus
          slotProps={{
            inputLabel: {
              shrink: true,
            },
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => handleClickShowPassword("current")}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                    size="large"
                  >
                    {showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
          onKeyDown={(e) => {
            if (e.key === Keys.ENTER) {
              if (newPasswordRef.current) {
                newPasswordRef.current?.focus();
              }
            }
          }}
        />

        <TextField
          required
          value={newPassword}
          className="change-password__textfield"
          name="password"
          type={showNewPassword ? "text" : "password"}
          onChange={(e) => setNewPassword(e.target.value)}
          label="New Password"
          inputRef={newPasswordRef}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => handleClickShowPassword("new")}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                    size="large"
                  >
                    {showNewPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
          onKeyDown={(e) => {
            if (e.key === Keys.ENTER) {
              if (confirmPasswordRef.current) {
                confirmPasswordRef.current?.focus();
              }
            }
          }}
        />

        <TextField
          required
          value={confirmPassword}
          className="change-password__textfield"
          name="password"
          label="Confirm Password"
          inputRef={confirmPasswordRef}
          type={showConfirmPassword ? "text" : "password"}
          onChange={(e) => setConfirmPassword(e.target.value)}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => handleClickShowPassword("confirm")}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                    size="large"
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
          onKeyDown={(e) => {
            if (e.key === Keys.ENTER) {
              if (captchaCodeRef.current) {
                captchaCodeRef.current?.focus();
              }
            }
          }}
        />
        <Label>Captcha code</Label>
        <div className="change-password__textfield--captcha">
          <div className="change-password__textfield--captcha--text">
            <span>{captchaText}</span>
          </div>

          <img src={UpdatedRefresh} alt="/" onClick={generateCaptcha} />
        </div>

        {/* <TextField
               slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        label="Captcha Code"
        value={captchaText}
        disabled
        InputProps={{
          endAdornment: (
            <img src={UpdatedRefresh} alt="/" onClick={generateCaptcha} />
          ),
        }}
        className="change-password__textfield--captcha"
      /> */}

        <TextField
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          label="Enter Captcha Code"
          inputRef={captchaCodeRef}
          className="change-password__textfield"
          type="text"
          value={userInput}
          onChange={handleUserInput}
          onKeyDown={(e) => {
            if (e.key === Keys.ENTER) {
              if (saveRef.current) {
                saveRef.current.focus();
              }
            }
          }}
        />
      </div>
      </div>

      <Button
        type="submit"
        mode="save"
        onClick={updatePasswordWithReauthentication}
        buttonref={saveRef}
      />
      <Button type="button" mode="clear" onClick={handleClear} />
      <Button
        mode="cancel"
        type="button"
        onClick={() => setPasswordModal(false)}
      />
      <MessageModal
        modalFlag={message.flag!}
        value={message.message!}
        handleClose={handleBack}
        operation={message.operation!}
      />
    </>
  );
};

export default ChangePassword;
